/** Status copy for the shared workspace loading screen. */
export const WORKSPACE_LOADING_COPY = {
  account: "Loading account",
  access: "Checking access",
  workspace: "Loading workspace",
  board: "Loading the board",
} as const;

export const WORKSPACE_LOADING_TEST_ID = "workspace-loading";
export const WORKSPACE_LOADING_EXIT_MS = 300;
